import styled, { css } from "styled-components"

import { Color, IsMobile, LineHeight, TextSize } from "~/consts/style-mixins"

export const EachTabContainer = styled.div`
  width: 100vw;
  margin: 0 calc(50% - 50vw);
  padding: 40px 0;
  background-color: ${Color.BackgroundGray};

  .content-wrapper {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 36px;
    background-color: ${Color.White};
    border-radius: 16px;
  }
  .each-section {
    margin: 40px 0;
    padding-bottom: 40px;
    border-bottom: 1px solid ${Color.BorderGray};
    &:first-child {
      margin-top: 0%;
    }
    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }
  .each-section-heading {
    margin-bottom: 8px;
  }
  .each-section-sub-heading {
    margin-bottom: 2px;
  }
  .section-content {
    margin-bottom: 40px;
    line-height: ${LineHeight.L}%;
    white-space: pre-wrap;
    &:last-child {
      margin-bottom: 0;
    }
    ${IsMobile(`
      font-size: ${TextSize.S}px;
    `)}
  }

  /* _Job */
  .occupation-container {
    width: 100%;
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Color.BackgroundSecondary};
    border-radius: 8px;
  }
  .occupation-icon {
    margin-right: 8px;
  }
  .occupation-description {
    ${IsMobile(css`
      font-size: 16px;
    `)}
  }
  .occupation-description-br {
    ${IsMobile(css`
      display: none;
    `)}
  }

  /* Company */
  .company-more-link {
    max-width: 415px;
    margin: 12px auto 0;
    display: block;
  }
`
